import React from "react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Link, Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow, TableSortLabel, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { ExtraPaddingLeftStyledCell, StyledTableCell } from "../../../../components/commonComponents/TabularLists/styles";
import { ArrowDropDown, ArrowDropUp, Check, Close } from "@mui/icons-material";
import { IconContainer, IconText, StyledBlackInformationTypography, StyledCheckbox, StyledDarkRedInformationTypography, StyledStack, StyledWhiteCheckbox } from "../../../../components/commonComponents/StyledComponents/styled";
import CloseButton from "../../../../components/commonComponents/Buttons/CloseButton";
import { formatDate } from "../../../../api_calls/utils";

const CustomSortIcon = ({ direction }) =>
    direction === 'asc' ? <ArrowDropUp /> : <ArrowDropDown />;

const StoreAvailabilityPopup = ({ open, closeModal }) => {
    const storeDetails = useSelector((state) => state.userSelections);
    // const dispatchAction = useDispatch()

    const [sortConfig, setSortConfig] = React.useState({
        key: "date",
        direction: "asc",
    });

    const handleSort = (key) => {
        setSortConfig((prevState) => {
            const isAsc = prevState.key === key && prevState.direction === "asc";
            return { key, direction: isAsc ? "desc" : "asc" };
        });
    };

    // store details 
    const storeDetail = typeof storeDetails.loop_store_availability !== "undefined" ? storeDetails.loop_store_availability : [];

    const storeAvailabilityDetails = typeof storeDetails.loop_store_availability !== "undefined" && typeof storeDetails.loop_store_availability.availability !== "undefined" ? [...storeDetails.loop_store_availability.availability].sort((a, b) => {
        const order = sortConfig.direction === "asc" ? 1 : -1;
        const aVal = a[sortConfig.key]?.toString().toLowerCase();
        const bVal = b[sortConfig.key]?.toString().toLowerCase();
        if (aVal < bVal) return -1 * order;
        if (aVal > bVal) return 1 * order;
        return 0;
    }) : [];

    return (
        <Dialog
            open={open}
            onClose={(e) => {
                e.preventDefault();
            }}
            fullWidth={true}
            maxWidth={"sm"}
        // fullScreen
        >
            <DialogTitle> Store Availability </DialogTitle>
            <DialogContent>
                <Box>
                    <StyledDarkRedInformationTypography variant="body2">
                        Store: {storeDetail.name}
                    </StyledDarkRedInformationTypography>
                </Box>
                <Box height={10} />
                <Box>
                    <Typography variant="body2">
                        Use the table to check why a store is unavailable for playout during your selected schedule.
                    </Typography>
                </Box>
                <Box height={10} />
                <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                    <Table aria-label="customized table">
                        {/* ------ header row ------ */}
                        <TableHead>
                            <TableRow>
                                <ExtraPaddingLeftStyledCell align="left" className="text-wrapper" sx={{ padding: "5px", fontSize: "13px" }}>
                                    <TableSortLabel
                                        active={sortConfig.key === "date"}
                                        direction={sortConfig.key === "date" ? sortConfig.direction : "asc"}
                                        onClick={() => handleSort("date")}
                                        hideSortIcon={false}
                                        IconComponent={() => (
                                            <CustomSortIcon direction={sortConfig.key === "date" ? sortConfig.direction : "asc"} />
                                        )}
                                        sx={{
                                            color: "white !important",
                                            '& .MuiTableSortLabel-icon': {
                                                opacity: "1!important",
                                                color: "white !important",
                                                visibility: 'visible !important',
                                            },
                                        }}
                                    >
                                        Date
                                    </TableSortLabel>

                                </ExtraPaddingLeftStyledCell>
                                <StyledTableCell align="left" className="text-wrapper" sx={{ padding: "5px", fontSize: "13px" }}>

                                    <TableSortLabel
                                        active={sortConfig.key === "status"}
                                        direction={sortConfig.key === "status" ? sortConfig.direction : "asc"}
                                        onClick={() => handleSort("status")}
                                        hideSortIcon={false}
                                        IconComponent={() => (
                                            <CustomSortIcon direction={sortConfig.key === "status" ? sortConfig.direction : "asc"} />
                                        )}
                                        sx={{
                                            color: "white !important",
                                            '& .MuiTableSortLabel-icon': {
                                                opacity: "1!important",
                                                color: "white !important",
                                                visibility: 'visible !important',
                                            },
                                        }}
                                    >
                                        Available
                                    </TableSortLabel>
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {storeAvailabilityDetails.map((store, index) => {
                                return (
                                    <TableRow key={index + "_campaign_row"}>
                                        {/* --------- name ---------- */}
                                        <ExtraPaddingLeftStyledCell
                                            component="td"
                                            scope="row"
                                            className="text-wrapper"
                                            sx={{ padding: "2px" }}
                                        >
                                            {formatDate(store.date)}
                                        </ExtraPaddingLeftStyledCell>
                                        {/* ---------- adress --------- */}
                                        <StyledTableCell component="td" scope="row" className="text-wrapper" sx={{ padding: "2px" }}>
                                            <StyledStack direction={"row"} spacing={2}>
                                                {
                                                    store.status !== "unavailable" ? <Check sx={{ color: "#AF3241" }} /> : <Close sx={{ color: "#E6E6E6" }} />
                                                }
                                                <IconText variant="body2" sx={{ fontSize: "11px", marginTop: "10px" }}>Remaining: {store.remaining_capacity}  </IconText>
                                            </StyledStack>
                                        </StyledTableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <CloseButton
                    onClick={(e) => {
                        e.preventDefault();
                        closeModal();
                    }}
                    label="Close"
                    icon={<Close />}
                />

            </DialogActions>
        </Dialog>
    );
};

export default StoreAvailabilityPopup;
